import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';
import 'app/store/LooksStore.js';
import 'app/store/ShoppingCartStore.js';
import 'app/store/JobStore.js';
import 'app/store/ContentStore.js';

function LtBrowseAndSelectLookDrawerCtrl(
  $scope,
  LooksStore,
  ShoppingCartStore,
  ContentStore,
  $filter,
  ContentChangeAction,
  $timeout,
  IrisService,
  JobStore,
  $q,
  $qHelperService,
  $location,
  $anchorScroll
) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  var getLookCategories = function () {
      var lookcategories = R.map(function (lookCategory) {
        return { lookCategory: lookCategory, lookName: $filter('ltTranslateFilter')(lookCategory) };
      })(LooksStore.getLookCategories());
      return lookcategories;
    },
    unbinder = ContentChangeAction.register(
      function () {
        this.refreshLookCategories();
      }.bind(this)
    );

  $scope.$on('$destroy', function () {
    unbinder();
  });

  this.isLoading = false;

  this.refreshLookCategories = function () {
    this.lookCategories = getLookCategories();
    var recentLookCategoryTitle =
      ShoppingCartStore.getCurrentSubject().subjectFirstName +
      ContentStore.getContent(null, 'USER_CATEGORY_APPEND_TEXT');
    this.recentLookCategory = { lookCategory: recentLookCategoryTitle, lookName: recentLookCategoryTitle };
    if (
      ShoppingCartStore.getCurrentSubject().recentLooks.length &&
      !R.contains(this.recentLookCategory, this.lookCategories)
    ) {
      this.lookCategories.unshift(this.recentLookCategory);
    }
    this.selectedLookCategory = this.lookCategories[0];
    this.selectedLookIndex = 0;
    this.selectedLook = {};
  };

  this.refreshLookCategories();
  this.looks = [];
  this.pageIndex = 0;

  this.getCurrentItemDesc = function () {
    return $scope.currentItemDesc;
  };

  this.refreshLooks = function () {
    if (this.selectedLookCategory.lookCategory === this.recentLookCategory.lookCategory) {
      this.looks = ShoppingCartStore.getCurrentSubject().recentLooks;
    } else {
      this.looks = LooksStore.getCategoryLooks(this.selectedLookCategory.lookCategory);
    }
    var deferred = $q.defer();

    // if reorder, start loading all the images in the look category
    if (JobStore.isReorder()) {
      this.isLoading = true;

      const promises = R.map(function (look) {
        const lookLocation = LooksStore.getPreviewImageLocation(look);
        return IrisService.load(lookLocation);
      })(this.looks || []);

      $qHelperService.allSettled(promises).then(deferred.resolve);
    } else {
      deferred.resolve();
    }

    deferred.promise.then(
      function () {
        this.selectedLook = this.looks[0];
        this.pageIndex = 0;
        this.isLoading = false;
      }.bind(this)
    );
  };

  this.refreshLooks();

  this.selectLook = function (selectedLook) {
    $scope.onSelectedLook({ selectedLook: selectedLook });
  };

  this.selectLookByPosition = function (position) {
    if (this.pageIndex + position < 0) {
      this.pageIndex = this.looks.length + position;
    } else if (this.pageIndex + position > this.looks.length) {
      this.pageIndex = this.looks.length - this.pageIndex;
    } else {
      this.pageIndex = this.pageIndex + position;
    }

    if (this.pageIndex === this.looks.length) {
      this.pageIndex = 0;
    }
  };

  this.onGoFavoriteLooks = function () {
    $scope.onGoFavoriteLooks();
  };

  this.getLook = function (position, fixed) {
    switch (position) {
      case -2:
        if (this.pageIndex === 1 && this.looks.length > 4) {
          return this.looks[this.looks.length - 1];
        }
        if (this.pageIndex < 2 && this.looks.length > 5) {
          return this.looks[this.looks.length - 2];
        }
        if (this.pageIndex === 0 && this.looks.length <= 5 && this.looks.length > 4) {
          return this.looks[this.looks.length - 2];
        }
        return this.looks[this.pageIndex - 2];
      case -1:
        if (this.pageIndex < 1 && this.looks.length > 3) {
          return this.looks[this.looks.length - 1];
        }
        return this.looks[this.pageIndex - 1];
      case 0:
        if (fixed === 'fixed') {
          var imageSrc = angular.element('#fixedImage')[0] ? angular.element('#fixedImage')[0].src : '';
          var imageLoc = LooksStore.getPreviewImageLocation(this.looks[this.pageIndex] || {});
          if (imageSrc.indexOf(imageLoc) >= 0) {
            this.disableNext = false;
          } else {
            this.disableNext = true;
          }
        }
        return this.looks[this.pageIndex];
      case 1:
        if (this.pageIndex === this.looks.length - 1 && this.looks.length > 3) {
          return this.looks[0];
        }
        return this.looks[this.pageIndex + 1];
      case 2:
        if (this.pageIndex === this.looks.length - 2 && this.looks.length >= 5) {
          return this.looks[0];
        }
        if (this.pageIndex >= this.looks.length - 2 && this.looks.length >= 5) {
          return this.looks[1];
        }
        if (this.pageIndex + 2 > this.looks.length && this.looks.length > 4) {
          return this.looks[this.pageIndex + 2 - (this.looks.length - 1)];
        }
        return this.looks[this.pageIndex + 2];
      default:
        return;
    }
  };

  this.prevPage = function () {
    if (this.pageIndex > 0) {
      this.pageIndex--;
    } else {
      this.pageIndex = this.looks.length - 1;
    }
  };

  this.nextPage = function () {
    if (this.pageIndex < this.looks.length - 1) {
      this.pageIndex++;
    } else {
      this.pageIndex = 0;
    }
  };

  this.chooseLook = function () {
    if (ShoppingCartStore.getCurrentSubject().recentLooks.length === 0) {
      this.lookCategories.unshift(this.recentLookCategory);
    }
    if (!R.contains(this.getLook(0), ShoppingCartStore.getCurrentSubject().recentLooks)) {
      ShoppingCartStore.getCurrentSubject().recentLooks.push(this.getLook(0));
      ShoppingCartStore.updateStorage();
    }

    $scope.onSelectedLook({ selectedLook: this.getLook(0) });

    this.scrollToLocation('sheets-gallery');
  };

  this.scrollToLocation = function (hashToScroll) {
    $timeout(function () {
      var old = $location.hash();
      $location.hash(hashToScroll);
      $anchorScroll(hashToScroll);
      $location.hash(old);
    }, 0);
  };
}

App.controller('LtBrowseAndSelectLookDrawerCtrl', [
  '$scope',
  'LooksStore',
  'ShoppingCartStore',
  'ContentStore',
  '$filter',
  'ContentChangeAction',
  '$timeout',
  'IrisService',
  'JobStore',
  '$q',
  '$qHelperService',
  '$location',
  '$anchorScroll',
  LtBrowseAndSelectLookDrawerCtrl
]);
